// Controls the sticky add-to-cart bar based on whether the real,
// in-page "Add to cart" button is currently visible on screen.
//   Real button visible   -> hide sticky bar
//   Real button NOT visible -> show sticky bar
function initStickyAddToCartOverride() {
  const stickyBars = document.querySelectorAll('product-sticky-add-to-cart');
  if (!stickyBars.length) return;

  stickyBars.forEach((stickyBar) => {
    const formId = stickyBar.getAttribute('main-product-form');
    if (!formId) return;

    // The real, static add-to-cart button lives inside <buy-buttons form="...">
    const realButtonWrapper = document.querySelector(`buy-buttons[form="${formId}"]`);
    if (!realButtonWrapper) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('is-visible');
          } else {
            stickyBar.classList.add('is-visible');
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(realButtonWrapper);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyAddToCartOverride);
} else {
  initStickyAddToCartOverride();
}